export const formatCurrency = (amount: number, currency: string = 'UAH') => {
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: currency,
    currencyDisplay: 'symbol',
  }).format(amount);
};

export const formatCurrencyAbs = (amount: number, currency: string = 'UAH') => {
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: currency,
  }).format(Math.abs(amount));
};

export const absInvert = (inAmount: number) => {
  let amount: number;
  if (inAmount > 0) {
    amount = -inAmount;
  } else {
    amount = Math.abs(inAmount);
  }
  return amount;
}

export const isAbsInvert = (inAmount: number) => {
  return inAmount <= 0;
}

export const formatCurrencyAbsInvert = (inAmount: number, currency: string = 'UAH') => {
  const amount = absInvert(inAmount);
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatCurrencyAbsNo = (amount: number) => {
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));
};

export const formatCurrencyAbsInt = (amount: number, currency: string = 'UAH') => {
  return new Intl.NumberFormat('uk-UA', {
    minimumFractionDigits: 0,
  }).format(Math.abs(amount));
};

export const cleanNbsp = (str: string) => {
  return str.replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
}
